<div class="chip-input-wrapper" [ngClass]="{ disabled: disabled }">
  <mat-form-field class="full-page-width flex-half">
    <mat-label>Extensions</mat-label>
    <mat-chip-grid #chipList [formControl]="chipsControl">
      @for (value of displayValues; track value) {
        <mat-chip-row
          [selectable]="false"
          [removable]="true"
          (removed)="removeValue(value)"
          >
          <span class="chip-label" [matTooltip]="getChipDisplay(value)">{{ getChipDisplay(value) }}</span>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
      <input
        autocomplete="off"
        #chipInput
        type="text"
        [formControl]="inputControl"
        [lcsSingleSelect]="groupSelect"
        name="extension-group-filter"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        [openPanelOnFocus]="true"
        (matChipInputTokenEnd)="add($event)"
        (input)="onInputChange($event)"
        (blur)="removeErrors()"
        placeholder="Search"
        />
      </mat-chip-grid>
    </mat-form-field>

    <div class="results-container">
      <ndt-extension-and-group-select
        #groupSelect
        (optionSelected)="selected($event)"
        [extensionGroups]="filteredExtensionGroups"
        [extensions]="filteredExtensions"
        [extensionGroupIdsToExclude]="extensionGroupIdsToExclude"
        [extensionIdsToExclude]="extensionIdsToExclude"
      ></ndt-extension-and-group-select>
    </div>
  </div>
